import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "MailAll"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M3 18H10.5V19.5H3C2.17157 19.5 1.5 18.8284 1.5 18V6C1.5 5.17157 2.17157 4.5 3 4.5H21C21.8284 4.5 22.5 5.17157 22.5 6V13.5H21V6.6825L12.4275 12.615C12.1704 12.7934 11.8296 12.7934 11.5725 12.615L3 6.6825V18ZM12 11.085L19.35 6H4.64995L12 11.085ZM12.4426 15.3075L15.1276 18L12.4351 20.6925L13.5001 21.75L17.2501 18L13.5001 14.25L12.4426 15.3075ZM20.3776 18L17.6926 15.3075L18.7501 14.25L22.5001 18L18.7501 21.75L17.6851 20.6925L20.3776 18Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/MailAll.vue"]]);
